// extracted by mini-css-extract-plugin
export default {"main":"contact_main__3-GIX","stringtext":"contact_stringtext__aMgQw","box":"contact_box__phOse","boxnew":"contact_boxnew__SiBa0"};